import React from 'react';
import i18next from 'i18next';
import { Field, Label, Control } from 'bloomer';
import { ErrorMessage } from 'formik';
import styled from 'styled-components';

import { colors } from '../../styles/colors';

type Props = {
  label?: string;
  noError?: boolean;
  name: string;
};

export class FormField extends React.PureComponent<Props> {

  render() {

    const { label, children, noError, name } = this.props;

    return (
      <FieldWithShadow>
        {label && <PaleLabel>{label}</PaleLabel>}

        <BorderlessControl>
          {children}
        </BorderlessControl>

        {
          (!noError) ?
            <ErrorMsgContainer className={'error'}>
              <ErrorMessage name={name} >{msg => <div className={`id-${name}-err`}>{i18next.t(msg)}</div>}</ErrorMessage>
            </ErrorMsgContainer> : undefined
        }
      </FieldWithShadow>
    );
  }
}

const FieldWithShadow = styled(Field)`
  background: white;
  border-radius: 0.5em;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  text-align: left;
  padding: 0.75em 1em;
`;

const PaleLabel = styled(Label)`
  font-weight: normal;
  font-size: 0.9em;
  color: ${colors.lightGreyColor};
  padding-left: 0.5rem;
  margin-bottom: 0 !important;
`;

const BorderlessControl = styled(Control)`
  input, select {
    border: 0;
    box-shadow: none;
    padding: 0.1rem 0.5rem;
    margin: 0.1em 0;
    height: 2em;

    &:focus {
      outline: none;
      box-shadow: none;
    }

    /* Remove blue background from autofilled fields */
    &:-webkit-autofill {
      box-shadow: 0 0 0 2rem white inset;
    }
  }
`;

const ErrorMsgContainer = styled.div`
  color: ${colors.red};
  font-size: 0.9em;
  padding-left: 0.5rem;
`;
